import axios from 'axios';
import { Constants } from 'src/constants/stringConstants';
import { CommonHelper } from 'src/utils/commonHelper';
import { DemoHelper } from 'src/utils/demoUtil/demoUtil';
import { LocalStorage } from 'src/utils/storage/local-storage';
import { demoModuleUrl, imageModeuleUrl, userModuleURL } from './urlService';
import { SessionStorage } from 'src/utils/storage/session-storage';

const getToken = () => {
  let cookie = LocalStorage.getItem('token');
  return cookie ? cookie : '';
};

const GetRequestHeader = (contentType = '', isNeedAutho, isNeedActiveBrandId = true) => {
  const activeBrandId = CommonHelper.GetCurrentBrandId();
  if (!activeBrandId && isNeedActiveBrandId) {
    let brandDetails = CommonHelper.GetBrandInfoFromLocalStorage('brand_details');
    if (brandDetails && brandDetails.length > 0) {
      SessionStorage.setItem('current_brand_id', JSON.stringify(brandDetails[0].brand_id));
      window.location.reload();
    }
  }
  const headers = {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': '*',
    'Content-type': contentType === 'form' ? 'multipart/form-data' : 'application/json',
    BrandId: isNeedAutho ? activeBrandId : '',
    Authorization: isNeedAutho ? getToken() : '',
  };
  return headers;
};

const GetDemoJson = (props) => {
  let { url, body, responseType, isNeedAutho = true, successCallback, failureCallback } = props;
  let config = { headers: GetRequestHeader('', isNeedAutho) };
  if (responseType) config.responseType = responseType;
  return axios
    .post(url, body, config)
    .then((result) => result)
    .then((response) => {
      if (response.status === 200) {
        if (response.data && response.data.http_code === 200) {
          typeof successCallback === 'function' && successCallback(response.data.data, response.data.message);
        } else if (response.data.http_code === 401) CommonHelper.Logout();
        else typeof failureCallback === 'function' && failureCallback(response.data.message);
      } else if (response.status === 401) CommonHelper.Logout();
      else typeof failureCallback === 'function' && failureCallback(Constants.SomethingWentWrongMsg);
    })
    .catch((error) => {
      if (error.message === 'Network Error') {
      }
      console.log(error);
      typeof failureCallback === 'function' && failureCallback(Constants.SomethingWentWrongMsg);
    });
};

const Get = (props) => {
  let { url, responseType, isNeedAutho = true, isNeedActiveBrandId = true, successCallback, failureCallback } = props;
  CommonHelper.CheckAndUpdateApiCallTime(url);
  if (DemoHelper.IsDemoAccount()) {
    var resp = DemoHelper.GetDemoJsonFileName(url);
    if (resp.json_file_name != 'no preloaded data') {
      props.url = `${demoModuleUrl.getDemoJson}`;
      props.body = resp;
      return GetDemoJson(props);
    }
  } else {
    let config = { headers: GetRequestHeader('', isNeedAutho, isNeedActiveBrandId) };
    if (responseType) config.responseType = responseType;
    return axios
      .get(url, config)
      .then((result) => result)
      .then((response) => {
        if (response.status === 200) {
          if (response.data && response.data.http_code === 200) {
            const urlObj = new URL(url);
            const path = urlObj.pathname;
            if (path == '/api/profile-master-services/private/initial-load') {
              if (response.data.data.is_demo_account) {
                var demojsonResp = DemoHelper.GetDemoJsonFileName(url);
                if (demojsonResp.json_file_name != 'no preloaded data') {
                  props.url = `${demoModuleUrl.getDemoJson}`;
                  props.body = demojsonResp;
                  return GetDemoJson(props);
                }
              } else {
                typeof successCallback === 'function' && successCallback(response.data.data, response.data.message);
              }
            } else {
              typeof successCallback === 'function' && successCallback(response.data.data, response.data.message);
            }
          } else if (response.data.http_code === 401) CommonHelper.Logout();
          else typeof failureCallback === 'function' && failureCallback(response.data.message);
        } else if (response.status === 401) CommonHelper.Logout();
        else typeof failureCallback === 'function' && failureCallback(Constants.SomethingWentWrongMsg);
      })
      .catch((error) => {
        if (error.message === 'Network Error') {
        }
        console.log(error);
        typeof failureCallback === 'function' && failureCallback(Constants.SomethingWentWrongMsg);
      });
  }
};

const Post = (props) => {
  let {
    url,
    body,
    successCallback,
    failureCallback,
    contentType,
    responseType,
    isNeedAutho = true,
    isNeedActiveBrandId = true,
    isFileUpload = false,
    progressCallback,
  } = props;
  CommonHelper.CheckAndUpdateApiCallTime(url);
  if (DemoHelper.IsDemoAccount()) {
    var demoResp = DemoHelper.GetDemoJsonFileName(url, body);
    if (demoResp.json_file_name != 'no preloaded data') {
      props.url = `${demoModuleUrl.getDemoJson}`;
      props.body = demoResp;
      return GetDemoJson(props);
    }
  } else {
    let config = isFileUpload
      ? { headers: GetRequestHeader(contentType, isNeedAutho, isNeedActiveBrandId) }
      : {
          headers: GetRequestHeader(contentType, isNeedAutho, isNeedActiveBrandId),
          onUploadProgress: (data) => {
            typeof progressCallback === 'function' && progressCallback(Math.round((100 * data.loaded) / data.total));
          },
        };
    if (responseType) config.responseType = responseType;
    return axios
      .post(url, body, config)
      .then((result) => result)
      .then((response) => {
        if (response.status === 200) {
          if (response.data && response.data.http_code === 200) {
            if (typeof successCallback === 'function') {
              successCallback(response.data.data, response.data.message);
            }
          } else if (response.data.http_code === 401) {
            CommonHelper.Logout();
          } else if (typeof failureCallback === 'function') {
            failureCallback(response.data.message);
          }
        } else if (response.status === 401) {
          CommonHelper.Logout();
        } else if (typeof failureCallback === 'function') {
          failureCallback(Constants.SomethingWentWrongMsg);
        }
      })
      .catch((error) => {
        if (error.message === 'Network Error') {
        }
        console.log(error);
        if (typeof failureCallback === 'function') {
          failureCallback(Constants.ErrorReachingServer);
        }
      });
  }
};
const LanguagePost = (props) => {
  let {
    url,
    body,
    successCallback,
    failureCallback,
    contentType,
    responseType,
    isNeedAutho = true,
    isNeedActiveBrandId = true,
    isFileUpload = false,
    progressCallback,
  } = props;
  CommonHelper.CheckAndUpdateApiCallTime(url);
  if (DemoHelper.IsDemoAccount()) {
    var demoResp = DemoHelper.GetDemoJsonFileName(url, body);
    if (demoResp.json_file_name != 'no preloaded data') {
      props.url = `${demoModuleUrl.getDemoJson}`;
      props.body = demoResp;
      return GetDemoJson(props);
    }
  } else {
    let config = isFileUpload
      ? { headers: GetRequestHeader(contentType, isNeedAutho, isNeedActiveBrandId) }
      : {
          headers: GetRequestHeader(contentType, isNeedAutho, isNeedActiveBrandId),
          onUploadProgress: (data) => {
            typeof progressCallback === 'function' && progressCallback(Math.round((100 * data.loaded) / data.total));
          },
        };
    if (responseType) config.responseType = responseType;
    return axios
      .post(url, body, config)
      .then((result) => result)
           .then((response) => {
        if (response.status === 200) {
          if (response.data) {
            if (typeof successCallback === 'function') {
              successCallback(response.data);
            }
          } else if (response.data.http_code === 401) {
            CommonHelper.Logout();
          } else if (typeof failureCallback === 'function') {
            failureCallback(response.data.message);
          }
        } else if (response.status === 401) {
          CommonHelper.Logout();
        } else if (typeof failureCallback === 'function') {
          failureCallback(Constants.SomethingWentWrongMsg);
        }
      })
      .catch((error) => {
        if (error.message === 'Network Error') {
        }
        console.log(error);
        if (typeof failureCallback === 'function') {
          failureCallback(Constants.ErrorReachingServer);
        }
      });
  }
};
const UploadMediaFiles = (props) => {
  if (DemoHelper.IsDemoAccount()) {
    var demoResp = DemoHelper.GetDemoJsonFileName(imageModeuleUrl.uploadMedia);
    if (demoResp.json_file_name != 'no preloaded data') {
      props.url = `${demoModuleUrl.getDemoJson}`;
      props.body = demoResp;
      return GetDemoUploadMedia(props);
    }
  } else {
    let { formData, setFileUploadprogress, successCallback, failureCallback } = props;
    setFileUploadprogress(1);
    return axios
      .post(imageModeuleUrl.uploadMedia, formData, {
        headers: GetRequestHeader('form', true),
        onUploadProgress: (data) => {
          let loadedProgress = Math.round((100 * data.loaded) / data.total);
          setFileUploadprogress(loadedProgress > 90 ? 90 : loadedProgress);
        },
      })
      .then((result) => result)
      .then((response) => {
        setFileUploadprogress(100);
        if (response.status === 200 && response.data.http_code === 200) {
          let mediaData = response.data && response.data?.data.media_data;
          if (mediaData && mediaData.length > 0) {
            let uploadedFiles = mediaData.map((uploadedData) => {
              return {
                media_url: uploadedData.media_url,
                thumbnail_urls: uploadedData.thumbnail_urls,
                aspect_ratio: uploadedData.aspect_ratio,
                video_length: uploadedData.video_length,
                media_type: uploadedData.media_type,
                file_size: uploadedData.file_size,
              };
            });
            successCallback(uploadedFiles, 'Files Uploaded Successfully');
          }
        } else failureCallback('Something went wrong. Please contact our technical team');
        setFileUploadprogress(0);
      })
      .catch((error) => {
        setFileUploadprogress(0);
        failureCallback(error.toString());
      });
  }
};
const GetImageFromAPI = (url) => {
  const activeBrandId = CommonHelper.GetCurrentBrandId();
  if (!activeBrandId) {
    let brandDetails = CommonHelper.GetBrandInfoFromLocalStorage('brand_details');
    if (brandDetails && brandDetails.length > 0) {
      SessionStorage.setItem('current_brand_id', JSON.stringify(brandDetails[0].brand_id));
      window.location.reload();
    }
  }

  if (DemoHelper.IsDemoAccount()) {
    var demoResp = DemoHelper.GetDemoJsonFileName(url);
    if (demoResp.json_file_name != 'no preloaded data') {
      let props = {};
      props.url = `${demoModuleUrl.getDemoJson}`;
      props.body = demoResp;
      return GetDemoImage(props);
    }
  } else {
    let config = {
      headers: {
        BrandId: activeBrandId,
        Authorization: getToken(),
      },
      responseType: 'arraybuffer',
    };
    return axios
      .get(url, config)
      .then((result) => result)
      .then((response) => {
        if (response.status === 200) {
          const blob = new Blob([response.data], { type: response.headers['content-type'] });
          return URL.createObjectURL(blob);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
};
const GetDemoImage = (props) => {
  let { url, body, isNeedAutho = true } = props;
  let config = { headers: GetRequestHeader('', isNeedAutho), responseType: 'arraybuffer' };

  return axios
    .post(url, body, config)
    .then((result) => result)
    .then((response) => {
      if (response.status === 200) {
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        return URL.createObjectURL(blob);
      }
    })
    .catch((error) => {
      console.log(error);
    });
};
const GetDemoUploadMedia = (props) => {
  let { url, body, isNeedAutho = true, setFileUploadprogress, successCallback, failureCallback } = props;
  let config = { headers: GetRequestHeader('', isNeedAutho) };
  return axios
    .post(url, body, config)
    .then((result) => result)
    .then((response) => {
      setFileUploadprogress(100);
      if (response.status === 200 && response.data.http_code === 200) {
        let mediaData = response.data && response.data?.data.media_data;
        if (mediaData && mediaData.length > 0) {
          let uploadedFiles = mediaData.map((uploadedData) => {
            return {
              media_url: uploadedData.media_url,
              thumbnail_urls: uploadedData.thumbnail_urls,
              aspect_ratio: uploadedData.aspect_ratio,
              video_length: uploadedData.video_length,
              media_type: uploadedData.media_type,
              file_size: uploadedData.file_size,
            };
          });
          successCallback(uploadedFiles, 'Files Uploaded Successfully');
        }
      } else if (typeof failureCallback === 'function') failureCallback(response.data.message);
      else failureCallback('Something went wrong. Please contact our technical team');
      setFileUploadprogress(0);
    })
    .catch((error) => {
      setFileUploadprogress(0);
      failureCallback(error.toString());
    });
};
const DownloadExcel = (props) => {
  let { url, isNeedAutho = true, isNeedActiveBrandId = true, successCallback, failureCallback } = props;
  CommonHelper.CheckAndUpdateApiCallTime(url);
  if (DemoHelper.IsDemoAccount()) {
    var resp = DemoHelper.GetDemoJsonFileName(url);
    if (resp.json_file_name != 'no preloaded data') {
      props.url = `${demoModuleUrl.getDemoJson}`;
      props.body = resp;
      return GetDemoJson({ ...props, responseType: 'arraybuffer' });
    }
  }
  let config = {
    headers: GetRequestHeader('', isNeedAutho, isNeedActiveBrandId),
    responseType: 'arraybuffer',
  };
  return axios
    .get(url, config)
    .then((result) => result)
    .then((response) => {
      if (response.status === 200) {
        const contentType = response.headers['content-type'] || '';
        if (contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
          typeof successCallback === 'function' && successCallback(response.data, 'Excel downloaded successfully');
        } else if (response.headers['content-type']?.includes('application/json')) {
          const text = new TextDecoder().decode(response.data);
          try {
            const json = JSON.parse(text);
            if (json.http_code === 401) {
              CommonHelper.Logout();
            } else {
              typeof failureCallback === 'function' && failureCallback(json.message || Constants.SomethingWentWrongMsg);
            }
          } catch (e) {
            typeof failureCallback === 'function' && failureCallback('Invalid response format');
          }
        } else {
          typeof failureCallback === 'function' && failureCallback('Unexpected response type: ' + contentType);
        }
      } else if (response.status === 401) {
        CommonHelper.Logout();
      } else {
        typeof failureCallback === 'function' && failureCallback(Constants.SomethingWentWrongMsg);
      }
    })
    .catch((error) => {
      console.log(error);
      if (error.response?.data) {
        const text = new TextDecoder().decode(error.response.data);
        try {
          const json = JSON.parse(text);
          if (json.http_code === 401) {
            CommonHelper.Logout();
          } else {
            typeof failureCallback === 'function' && failureCallback(json.message || Constants.ErrorReachingServer);
          }
        } catch (e) {
          typeof failureCallback === 'function' && failureCallback(Constants.ErrorReachingServer);
        }
      } else {
        typeof failureCallback === 'function' && failureCallback(Constants.ErrorReachingServer);
      }
    });
};
const DownloadCSV = (props) => {
  let { url, isNeedAutho = true, isNeedActiveBrandId = true, successCallback, failureCallback } = props;
  CommonHelper.CheckAndUpdateApiCallTime(url);
  if (DemoHelper.IsDemoAccount()) {
    var resp = DemoHelper.GetDemoJsonFileName(url);
    if (resp.json_file_name != 'no preloaded data') {
      props.url = `${demoModuleUrl.getDemoJson}`;
      props.body = resp;
      return GetDemoJson({ ...props, responseType: 'arraybuffer' });
    }
  }
  let config = {
    headers: GetRequestHeader('', isNeedAutho, isNeedActiveBrandId),
    responseType: 'arraybuffer', // Required for CSV binary data
  };
  return axios
    .get(url, config)
    .then((result) => result)
    .then((response) => {
      if (response.status === 200) {
        // Check if response is binary CSV data
        const contentType = response.headers['content-type'] || '';
        if (contentType.includes('text/csv')) {
          typeof successCallback === 'function' && successCallback(response.data, 'CSV downloaded successfully');
        } else if (response.headers['content-type']?.includes('application/json')) {
          // Handle JSON error response
          const text = new TextDecoder().decode(response.data);
          try {
            const json = JSON.parse(text);
            if (json.http_code === 401) {
              CommonHelper.Logout();
            } else {
              typeof failureCallback === 'function' && failureCallback(json.message || Constants.SomethingWentWrongMsg);
            }
          } catch (e) {
            typeof failureCallback == 'function' && failureCallback('Invalid response format');
          }
        } else {
          typeof failureCallback === 'function' && failureCallback('Unexpected response type: ' + contentType);
        }
      } else if (response.status === 401) {
        CommonHelper.Logout();
      } else {
        typeof failureCallback === 'function' && failureCallback(Constants.SomethingWentWrongMsg);
      }
    })
    .catch((error) => {
      console.log(error);
      if (error.response?.data) {
        // Try to decode error response if it's JSON
        const text = new TextDecoder().decode(error.response.data);
        try {
          const json = JSON.parse(text);
          if (json.http_code === 401) {
            CommonHelper.Logout();
          } else {
            typeof failureCallback === 'function' && failureCallback(json.message || Constants.ErrorReachingServer);
          }
        } catch (e) {
          typeof failureCallback === 'function' && failureCallback(Constants.ErrorReachingServer);
        }
      } else {
        typeof failureCallback === 'function' && failureCallback(Constants.ErrorReachingServer);
      }
    });
};
const SaveAiContent = (props) => {
  const { formData, setFileUploadProgress, successCallback, failureCallback } = props;

  if (DemoHelper.IsDemoAccount()) {
    const demoResp = DemoHelper.GetDemoJsonFileName(userModuleURL.uploadAiContent);
    if (demoResp.json_file_name !== 'no preloaded data') {
      props.url = `${demoModuleUrl.getDemoJson}`;
      props.body = demoResp;
      return GetDemoJson({ ...props, contentType: 'form' });
    }
  }

  // Ensure formData is valid
  if (!(formData instanceof FormData)) {
    console.error('Invalid formData: Expected FormData object');
    failureCallback('Invalid form data');
    return Promise.reject(new Error('Invalid form data'));
  }

  return axios
    .post(userModuleURL.uploadAiContent, formData, {
      headers: GetRequestHeader('form', true),
    })
    .then((result) => result)
    .then((response) => {
      if (response.status === 200) {
        if (response.data && response.data.http_code === 200) {
          if (typeof successCallback === 'function') {
            successCallback(response.data.data, response.data.message);
          }
        } else if (response.data.http_code === 401) {
          CommonHelper.Logout();
        } else if (typeof failureCallback === 'function') {
          failureCallback(response.data.message);
        }
      } else if (response.status === 401) {
        CommonHelper.Logout();
      } else if (typeof failureCallback === 'function') {
        failureCallback(Constants.SomethingWentWrongMsg);
      }
      if (typeof setFileUploadProgress === 'function') {
        setFileUploadProgress(0);
      }
    })
    .catch((error) => {
        if (error.message === 'Network Error') {
        }
        console.log(error);
        if (typeof failureCallback === 'function') {
          failureCallback(Constants.ErrorReachingServer);
        }
      });
};
const HttpServices = {
  Post,
  Get,
  GetRequestHeader,
  GetImageFromAPI,
  UploadMediaFiles,
  DownloadCSV,
  DownloadExcel,
  SaveAiContent,
  LanguagePost,
};

export default HttpServices;
